import React, { useEffect, useState } from "react";

import CompanyAlertTypes from "./CompanyAlertTypes";
import CompanyAlertEscalation from "./CompanyAlertEscolation";
import { get, post } from "../../../Services/ApiHandler";
import { URL } from "../../../Services/Constant";

const CompanyAlertMain = () => {
  const [site, setSite] = useState([]);
  const [siteList, setSiteList] = useState([]);
  const [alertData, setAlertData] = useState([]);
  const [alertDatas, setAlertDatas] = useState([]);

  const [activeTab, setActiveTab] = useState("types");

  useEffect(() => {
    const stored = localStorage.getItem("types");
    if (stored) {
      setActiveTab(JSON.parse(stored));
    } else {
      setActiveTab("types");
      localStorage.setItem("types", JSON.stringify("types"));
    }
  }, []);

  const handleTab = (type) => {
    setActiveTab(type);
    localStorage.setItem("types", JSON.stringify(type));
    // setSite([]);
  };

  const getSiteList = () => {
    get(URL.ACTIVE_SITE + "?knf_type=1")
      .then((res) => {
        if (res?.sites?.length > 0) {
          setSiteList(res?.sites);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getAlert = (site_id, type) => {
    if (type !== "list") {
      setSite(site_id);
    }

    if (site_id) {
      let formdata = new FormData();
      formdata.append("site_id", site_id?.value);
      post(URL.SITE_ALERT_TYPES_LIST, formdata)
        .then((res) => {
          if (res?.lists?.length > 0) {
            setAlertData(res?.lists);
          } else {
            setAlertData([]);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      setAlertData([]);
    }
  };

  const getAlerts = (site_id, type) => {
    if (type !== "list") {
      setSite(site_id);
    }

    if (site_id) {
      let formdata = new FormData();
      formdata.append("site_id", site_id?.value);
      post(URL.SITE_ALERT_ESCULATION_LIST, formdata)
        .then((res) => {
          if (res?.lists?.length > 0) {
            setAlertDatas(res?.lists);
          } else {
            setAlertDatas([]);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      setAlertDatas([]);
    }
  };

  useEffect(() => {
    getSiteList();
  }, []);

  const handleSwitch = (site_id, type) => {
    getAlert(site_id, type);
    getAlerts(site_id, type);
  };

  // console.log("site", site);

  return (
    <div className="dashRightView">
      <div className="tab-header d-flex gap-3 mb-3">
        <button
          className={`tab-btn ${activeTab === "types" ? "active" : ""}`}
          onClick={() => handleTab("types")}
        >
          Alert Types
        </button>
        <button
          className={`tab-btn ${activeTab === "escalation" ? "active" : ""}`}
          onClick={() => handleTab("escalation")}
        >
          Alert Escalation Time
        </button>
      </div>

      <div>
        {activeTab === "types" && (
          <CompanyAlertTypes
            site={site}
            setSite={setSite}
            siteList={siteList}
            setAlertData={setAlertData}
            alertData={alertData}
            getAlert={handleSwitch}
          />
        )}
        {activeTab === "escalation" && (
          <CompanyAlertEscalation
            site={site}
            setSite={setSite}
            siteList={siteList}
            setAlertData={setAlertDatas}
            alertData={alertDatas}
            getAlert={handleSwitch}
          />
        )}
      </div>
    </div>
  );
};

export default CompanyAlertMain;
